import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

export default function CtaSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="contact"
      className="w-full h-screen flex flex-col items-center justify-center relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #FA6E4F 0%, #FB8E7E 100%)' }}
    >
      {/* Floating icons */}
      {[
        { icon: 'ri-code-line', x: '8%', y: '15%', size: 60, delay: 0 },
        { icon: 'ri-rocket-line', x: '88%', y: '20%', size: 48, delay: 0.5 },
        { icon: 'ri-lightbulb-line', x: '5%', y: '75%', size: 40, delay: 1 },
        { icon: 'ri-shield-check-line', x: '92%', y: '70%', size: 52, delay: 0.3 },
        { icon: 'ri-global-line', x: '50%', y: '8%', size: 36, delay: 0.8 },
      ].map((item, i) => (
        <div
          key={i}
          className="absolute pointer-events-none"
          style={{
            left: item.x,
            top: item.y,
            opacity: 0.15,
            animation: `float ${3 + i * 0.5}s ease-in-out infinite alternate`,
            animationDelay: `${item.delay}s`,
          }}
        >
          <i className={`${item.icon} text-white`} style={{ fontSize: item.size }} />
        </div>
      ))}

      {/* Content */}
      <div
        className={`relative z-10 text-center transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-16'}`}
      >
        <p className="text-white/60 text-xs tracking-[0.5em] uppercase mb-10">Ready to grow?</p>
        <h2
          className="boldonse text-white leading-none mb-4"
          style={{ fontSize: 'clamp(80px, 14vw, 180px)', WebkitTextStroke: '2px rgba(255,255,255,0.3)' }}
        >
          LET&apos;S TALK
        </h2>
        <p className="text-[#F2CF59] text-xl mb-12 font-medium">Start your digital transformation today</p>

        <div className="flex items-center justify-center gap-4 flex-wrap max-w-xl mx-auto px-4">
          <Link
            to="/contact"
            className="boldonse px-8 py-3 rounded-full text-[#FA6E4F] text-lg transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            style={{ background: '#F2CF59' }}
          >
            GET IN TOUCH
          </Link>
          <Link
            to="/services"
            className="boldonse px-8 py-3 rounded-full text-white text-lg border-2 border-white/40 transition-all duration-300 hover:scale-105 hover:bg-white/10 whitespace-nowrap cursor-pointer"
          >
            OUR SERVICES
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes float {
          from { transform: translateY(0px) rotate(0deg); }
          to { transform: translateY(-20px) rotate(10deg); }
        }
      `}</style>
    </section>
  );
}